import { onShowExpandButton } from '../actions/internalActions';
import { mutator } from 'satcheljs';
import getRecentAttachmentsPillsData from '../selectors/getRecentAttachmentsPillsData';

mutator(onShowExpandButton, actionMessage => {
    const recentAttachmentsPillsData = getRecentAttachmentsPillsData(actionMessage.composeId);
    if (recentAttachmentsPillsData) {
        recentAttachmentsPillsData.showExpandButton = actionMessage.isOverFlow;
    }
});
